import Nullstack from 'nullstack';
export default function IconArrowMergeRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-merge-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 8l-4 -4l-4 4"
  }), "   ", Nullstack.element("path", {
    d: "M12 20v-16"
  }), "   ", Nullstack.element("path", {
    d: "M18 18c-4 -1.333 -6 -4.667 -6 -10"
  }), " ");
}